import React from "react";
import { Sparkles } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { useCampaign } from "@/context/CampaignContext";

export const CampaignBanner = () => {
  const { lang } = useLanguage();
  const { campaign } = useCampaign();
  if (!campaign.active) return null;
  const name = lang === "ar" ? campaign.name_ar : campaign.name_en;
  return (
    <div
      data-testid="campaign-banner"
      className="relative overflow-hidden bg-gradient-to-r from-[#D4AF37] via-[#f0d87a] to-[#D4AF37] text-[#0A0A0B]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-2 flex items-center justify-center gap-2 text-sm font-medium">
        <Sparkles size={16} className="animate-pulse" />
        <span className="num-ltr">
          {name} · ×{campaign.multiplier} {lang === "ar" ? "على منتجات مختارة" : "on selected products"}
        </span>
        <Sparkles size={16} className="animate-pulse" />
      </div>
    </div>
  );
};
